export const mapGpsDto = (dto) => {
    let instant = null;
    if (dto.instant) {
        if (typeof dto.instant === 'string') {
            const containsOnlyNumbers = /^\d+$/.test(dto.instant);
            if (containsOnlyNumbers) {
                instant = new Date(parseInt(dto.instant, 10));
            }
            else {
                instant = new Date(dto.instant);
            }
        }
        else {
            instant = new Date(dto.instant);
        }
    }
    return {
        ...dto,
        position: {
            ...dto.position,
            coordinates: [...dto.position.coordinates].reverse(),
        },
        instant,
    };
};
export const mapGpsEntityDTO = (dto) => ({
    ...dto,
    gps: dto.gps ? mapGpsDto(dto.gps) : null,
});
export const mapVehicleDtoVehicle = (dto) => ({
    ...mapGpsEntityDTO(dto),
});
export const toVehicleMarker = (vehicle) => ({
    heading: 2,
    color: vehicle.vehicleStatus ? `#${vehicle.vehicleStatus.color}` : '#FFF',
    icon: vehicle.icon,
    id: vehicle.id,
    location: vehicle.gps.position.coordinates,
});
//# sourceMappingURL=vehicle.mapper.js.map